import { adminInstance } from "@/api/instance";

export default async function (beautyId, data) {
  return adminInstance.put(`/beauty/${beautyId}`, data);
}
